/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpServerToolMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMcpServerToolMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMcpServerToolMetadataSecurity = {
  option1?: ListMcpServerToolMetadataSecurityOption1 | undefined;
  option2?: ListMcpServerToolMetadataSecurityOption2 | undefined;
};

export type ListMcpServerToolMetadataRequest = {
  /**
   * The ID of the MCP server the tool metadata belongs to
   */
  mcpServerId: string;
  /**
   * Include soft-deleted tool metadata entries in the result. Deleted entries carry a deleted_at timestamp.
   */
  includeDeleted?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMcpServerToolMetadataSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMcpServerToolMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListMcpServerToolMetadataSecurityOption1$Outbound,
    ListMcpServerToolMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listMcpServerToolMetadataSecurityOption1ToJSON(
  listMcpServerToolMetadataSecurityOption1:
    ListMcpServerToolMetadataSecurityOption1,
): string {
  return JSON.stringify(
    ListMcpServerToolMetadataSecurityOption1$outboundSchema.parse(
      listMcpServerToolMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMcpServerToolMetadataSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMcpServerToolMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListMcpServerToolMetadataSecurityOption2$Outbound,
    ListMcpServerToolMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listMcpServerToolMetadataSecurityOption2ToJSON(
  listMcpServerToolMetadataSecurityOption2:
    ListMcpServerToolMetadataSecurityOption2,
): string {
  return JSON.stringify(
    ListMcpServerToolMetadataSecurityOption2$outboundSchema.parse(
      listMcpServerToolMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMcpServerToolMetadataSecurity$Outbound = {
  Option1?: ListMcpServerToolMetadataSecurityOption1$Outbound | undefined;
  Option2?: ListMcpServerToolMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMcpServerToolMetadataSecurity$outboundSchema: z.ZodMiniType<
  ListMcpServerToolMetadataSecurity$Outbound,
  ListMcpServerToolMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMcpServerToolMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMcpServerToolMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMcpServerToolMetadataSecurityToJSON(
  listMcpServerToolMetadataSecurity: ListMcpServerToolMetadataSecurity,
): string {
  return JSON.stringify(
    ListMcpServerToolMetadataSecurity$outboundSchema.parse(
      listMcpServerToolMetadataSecurity,
    ),
  );
}

/** @internal */
export type ListMcpServerToolMetadataRequest$Outbound = {
  mcp_server_id: string;
  include_deleted?: boolean | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMcpServerToolMetadataRequest$outboundSchema: z.ZodMiniType<
  ListMcpServerToolMetadataRequest$Outbound,
  ListMcpServerToolMetadataRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    includeDeleted: z.optional(z.boolean()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      includeDeleted: "include_deleted",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMcpServerToolMetadataRequestToJSON(
  listMcpServerToolMetadataRequest: ListMcpServerToolMetadataRequest,
): string {
  return JSON.stringify(
    ListMcpServerToolMetadataRequest$outboundSchema.parse(
      listMcpServerToolMetadataRequest,
    ),
  );
}
